import { type Ref, ref, computed } from "vue";
import apiSkobo from "@/helpers/api/apiSkobo";

export const useLeftMenuSetup = () => {
  const leftMenuState: Ref<unknown[]> = ref([]);

  const leftMenu = computed(() => leftMenuState.value);
  const leftShortcuts = computed<unknown[]>(() => []);

  const reloadLeftMenu = async () => {
    const response = await apiSkobo.get("/navigation/menu");
    leftMenuState.value = response.data.values;
  };

  const loadLeftMenu = async () => {
    if (leftMenuState.value.length === 0) {
      reloadLeftMenu();
    }
  };

  return {
    leftMenuState,
    leftMenu,
    leftShortcuts,
    loadLeftMenu,
    reloadLeftMenu
  };
};
